export function getRandomInt(min, max) {
    const minVal = Math.ceil(min);
    const maxVal = Math.floor(max);
    return Math.floor(Math.random() * (maxVal - minVal)) + minVal;
}

export function open_window(url, width, height) {
    const center_left = screen.width / 2 - width / 2;
    const center_top = screen.height / 2 - height / 2;
    const thewindow = window.open(url, 'Title', `scrollbars=1, width=${width}, height=${height}, left=${center_left}, top=${center_top}`);
    thewindow?.focus();
}

export function scrollToTop() {
    const $j = window.$j;
    $j('html:not(:animated), body:not(:animated)').animate({ scrollTop: 0 }, { duration: 1200, easing: 'easeInOutExpo' });
}

export function titleCase(str) {
    return str
        .split('-')
        .map((i) => i[0].toUpperCase() + i.substr(1).toLowerCase())
        .join(' ');
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}

export function getUrlVars() {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (_m, key, value) => {
        vars[key] = value;
    });
    return vars;
}

export function formatPhoneNumber(s) {
    const s2 = ('' + s).replace(/\D/g, '');
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
}

export function datasort(_data, a, b) {
    return a.localeCompare(b);
}

window.getRandomInt = getRandomInt;
window.scrollToTop = scrollToTop;
